var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCart = function SvgIconCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 18,
    height: 14,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8C19 4.68629 16.3137 2 13 2C9.68629 2 7 4.68629 7 8",
    strokeWidth: 3
  })));
};
export default SvgIconCart;